export const SET_AUTH = "SET_AUTH";
export const SET_CAMPAIGN = "SET_CAMPAIGN";
export const SET_CAMPAIGN_VARIANT = "SET_CAMPAIGN_VARIANT";
export const SET_NAVBAR_VISIBLE = "SET_NAVBAR_VISIBLE";
export const SET_MODAL_VISIBLE = "SET_MODAL_VISIBLE";
export const SET_ANIMATION = "SET_ANIMATION";
export const SET_GA = "SET_GA";
export const SET_DATA = "SET_DATA";
export const SET_BOTTLE_ID = "SET_BOTTLE_ID";
